import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { Box } from '@mui/material';
import { ConsolidationDataScoreInadimplenciaType } from '@/features/dashboard/types/ConsolidationDataScoreInadimplencia.ts';
import { formatLargeNumber } from '@/utils/formatLargNumber';

type ScoreInadimplenciaProps = {
  data: ConsolidationDataScoreInadimplenciaType;
};

const ScoreInadimplencia: React.FC<ScoreInadimplenciaProps> = ({ data }) => {
  const monthOrder = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun',
  'jul', 'ago', 'set', 'out', 'nov', 'dez'];

  const sortedValorMeses = [...data.valor_meses].sort(
    (a, b) => monthOrder.indexOf(a.nome) - monthOrder.indexOf(b.nome)
  );

  const months = sortedValorMeses.map((item) => item.nome);
  const values = sortedValorMeses.map((item) => item.valor);
  const secondaryValues = sortedValorMeses.map((item) => item.valor_secundario);
  const tertiaryValues = sortedValorMeses.map((item) => item.valor_terciario);

  const series = [
    {
      data: values,
      type: 'bar',
      stack: 'a',
      name: 'Pago',
      itemStyle: {
        color: 'rgba(147, 220, 63, 1)',
      },
    },
    {
      data: secondaryValues,
      type: 'bar',
      stack: 'a',
      name: 'Vencido',
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: 'rgba(252, 159, 159, 1)',
      },
      label: {
        show: true,
        position: 'top',
        formatter: (params) => `{value|${formatLargeNumber(Number(params.value))}}\n{arrow|▼}`,
        rich: {
          value: {
            backgroundColor: 'rgba(246, 190, 51, 1)',
            color: '#000',
            fontSize: 11,
            padding: [5, 15],
            borderRadius: 5,
          },
          arrow: {
            color: '#F6BE33',
            fontSize: 20,
            align: 'center',
          },
        },
      },
    },
    {
      name: '% Inad.',
      type: 'line',
      smooth: true,
      yAxisIndex: 1,
      data: tertiaryValues,
      lineStyle: {
        color: 'black',
        width: 3,
      },
    },
  ];

  const option = {
    title: {
      text: 'Visão histórica de inadimplência',
      padding: [
        16,
        5,
        5,
        23,
      ],
      textStyle: {
        fontSize: '14px'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
      },
      formatter: (params) => {
        const tooltipItems = params.map((item) => {
          const value = item.value;
          const formattedValue = item.seriesName === '% Inad.' ? `${value.toFixed(2)}%` : formatLargeNumber(value);
          return `<div><strong>${item.seriesName}:</strong> ${formattedValue}</div>`;
        }).join('');

        return `<div><strong>${params[0].name}</strong></div>${tooltipItems}`;
      },
    },
    legend: {
      data: [
        {name: 'Pago', icon: 'circle'},
        {name: 'Vencido', icon: 'circle'},
        '% Inad.'
      ],
      /* data: ['Pago', 'Vencido', '% Inad.'], */
      right: '0',
      padding: [
        16,
        23,
        5,
        5,
      ],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '20%',
      containLabel: true,
    },
    yAxis: [
      {
        type: 'value',
      },
      {
        type: 'value',
        axisLabel: {
          formatter: '',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ScoreInadimplencia;